import { Flex, Typography } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import styled from "styled-components"

export const GemContainer = styled(Flex).attrs((props) => ({
  alignContent: "flex-start",
  flexWrap: "wrap",
  justifyContent: { _: "center", tablet: "flex-start" },
  margin: "auto",
  width: { _: "90%", desktop: "75%" },
  ...props,
}))``

export const GemLink = styled(Typography).attrs({
  as: Link,
  color: "primary",
})`
  text-decoration: underline;
`
